import { Box, useTheme } from "@mui/material";
import React from "react";
import AppFooter from "../../components/footer";
import Header from "../../components/header";
import AllSchools from "./AllSchools";
import Products from "./Products";

const EducationalCity = () => {
  const { palette } = useTheme();
  

  return (
    <>
      <Box
        height={"100vh"}
        sx={{
          background: palette.gradient.background,
        }}
      >
        <Header />
      </Box>
      <AllSchools />
      <Products/>

      <AppFooter />
    </>
  );
};

export default EducationalCity;
